/* eslint-disable react/jsx-no-undef */
//import { Counter } from "./components/Counter";
//import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { FriendAndFamily } from "./components/FriendAndFamily/FriendAndFamily";
import { CustomerPaymentInfo } from "./components/FriendAndFamily/CustomerPaymentInfo/CustomerPaymentInfo";
import { ThankYouPage } from "./components/FriendAndFamily/ThankYouPage";
import ErrorPage from "./components/ErrorPage";
import { MySwagCreator } from "./components/BecomeASwagCreator/MySwagCreator";
import { DKDOffer } from "./components/DKDOffer/DKDOffer";
import BecomeOurPartnerMain from "./components/BecomeOurPartners/BecomeOurPartnerMain";
import { PaymentStatus } from "./components/PaymentStatus/PaymentStatus";
import { DishKiChampionsTrophy } from "./components/DishKiChampionsTrophy/DishKiChampionsTrophy";
import { IPLContestWatcho } from "./components/IPLContestWatcho/IPLContestWatcho";
import { LeaderBoard } from "./components/IPLContestWatcho/Pages/LeaderBoard/LeaderBoard";

import { PastWinner } from "./components/IPLContestWatcho/Pages/PastWinner/PastWinner";
import { WatchoDownload } from "./components/WatchoDownload/WatchoDownload";
import Grievance from "./components/WatchoGrievance/Grievance";
import Report from "./components/WatchoGrievance/ComplianceReport/Report";
import ContactUS from "../src/pages/contactus/ContactUs";
import Faq from "./pages/faq/faq";
//import {ContactUs as VZY} from "./components/faq_becomeOurPartner_help_vzy/contactus";
import VZYContactUs from "./components/VZY/HelpAndSupport/contactus/ContactUs";
import { VzyFriendAndFamily } from "./components/VZY/FriendAndFamily/VzyFriendAndFamily";
import VzyBecomeOurPartnerMain from "./components/VZY/BecomeOurPartners/VzyBecomeOurPartnerMain";
import VzyReport from "./components/VZY/VZYGrievance/ComplianceReport/VzyReport";
import VzyGrievance from "./components/VZY/VZYGrievance/VzyGrievance";
import { VZYPaymentStatus } from "./components/VZY/PaymentStatus/VZYPaymentStatus";
import { VZYThankYouPage } from "./components/VZY/FriendAndFamily/VZYThankYouPage";
import { VZYCustomerPaymentInfo } from "./components/VZY/FriendAndFamily/CustomerPaymentInfo/VZYCustomerPaymentInfo";
import VZYFaq from "./components/VZY/HelpAndSupport/faq/faq";
import { HelpSupport } from "./components/VZY_Help_Support/help_support/HelpSupport";
import { VideoList } from "./components/VZY_Help_Support/videos_list/VideoList";
import { VideosDetails } from "./components/VZY_Help_Support/videos_details/VideosDetails";
import { FaqList } from "./components/VZY_Help_Support/faq_list/FaqList"; //PopularTopicsdetails
import { FaqDetails } from "./components/VZY_Help_Support/faq_details/FaqDetails";
import { PopularTopicsdetails } from "./components/VZY_Help_Support/popularTopicsdetails/PopularTopicsdetails";
import { SearchList } from "./components/VZY_Help_Support/search_list/SearchList";
import { PopularTopicsList } from "./components/VZY_Help_Support/popularTopicsList/PopularTopicsList";
import { NoResultsFound } from "./components/VZY_Help_Support/no_results_found/NoResultsFound";
import { Tickets } from "./components/VZY_Help_Support/MyTickets/Tickets";
const AppRoutes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "/family-and-friends",
    element: <FriendAndFamily />,
  },
  {
    path: "/customer-info",
    element: <CustomerPaymentInfo />,
  },
  {
    path: "/thankyou-page",
    element: <ThankYouPage />,
  },
  {
    path: "/errorPage",
    element: <ErrorPage />,
  },
  {
    path: "/BecomeOurPartner",
    element: <BecomeOurPartnerMain />,
  },
  {
    path: "/BecomeSwagCreator",
    element: <MySwagCreator />,
  },
  {
    path: "/DKD2024",
    element: <DKDOffer />,
  },
  {
    path: "/PaymentStatus",
    element: <PaymentStatus />,
  },
  {
    path: "/DishKiChampionsTrophy",
    element: <DishKiChampionsTrophy />,
  },
  {
    path: "/IPLContestWatcho",
    element: <IPLContestWatcho />,
  },
  {
    path: "/Leaderboard",
    element: <LeaderBoard />,
  },
  {
    path: "/PastWinner",
    element: <PastWinner />,
  },
  {
    path: "/WatchoDownload",
    element: <WatchoDownload />,
  },
  {
    path: "/WatchoGrievance",
    element: <Grievance />,
  },
  {
    path: "/WatchoGrievanceReport",
    element: <Report />,
  },

  {
    path: "/Help/help-support",
    element: <ContactUS />,
  },
  {
    path: "Help/FAQ",
    element: <Faq />,
  },
  {
    path: "VZY/Help/help-support",
    element: <VZYContactUs />,
  },
  {
    path: "VZY/Help/FAQ",
    element: <VZYFaq />,
  },

  // VZY URL start here
  {
    path: "VZY/family-and-friends",
    element: <VzyFriendAndFamily />,
  },
  {
    path: "VZY/BecomeOurPartner",
    element: <VzyBecomeOurPartnerMain />,
  },
  {
    path: "VZY/Report",
    element: <VzyReport />,
  },
  {
    path: "VZY/Grievance",
    element: <VzyGrievance />,
  },
  {
    path: "/VzyPaymentStatus",
    element: <VZYPaymentStatus />,
  },
  {
    path: "/VZYthankyou-page",
    element: <VZYThankYouPage />,
  },
  {
    path: "/VZYCustomer-info",
    element: <VZYCustomerPaymentInfo />,
  },
  // VZY URL end here

  // VZY Help and Support start here
  {
    path: "VZYSupport/helpSupport?a_t=:token",
    element: <HelpSupport />,
  },
  {
    path: "VZYSupport/helpSupport",
    element: <HelpSupport />,
  },
  {
    path: "VZYSupport/VideoList",
    element: <VideoList />,
  },
  {
    path: "VZYSupport/video/:slug",
    element: <VideosDetails />,
  },
  {
    path: "VZYSupport/FaqList",
    element: <FaqList />,
  },
  {
    path: "VZYSupport/MyTickets",
    element: <Tickets />,
  },
  {
    path: "VZYSupport/details",
    element: <FaqDetails />,
  },
  {
    path: "VZYSupport/details/:slug",
    element: <FaqDetails />,
  },
  {
    path: "VZYSupport/PopularTopicsList",
    element: <PopularTopicsList />,
  },
  {
    path: "VZYSupport/PopularTopics/:slug",
    element: <PopularTopicsList />,
  },
  {
    path: "VZYSupport/PopularTopicsdetails/:slug",
    element: <PopularTopicsdetails />,
  },
  {
    path: "VZYSupport/NoResultsfound",
    element: <NoResultsFound />,
  },
  {
    path: "VZYSupport/SearchList",
    element: <SearchList />,
  },
];

export default AppRoutes;
